import type { ListFile } from '@shared/model'
import type {
  DisciplineFilePackDetails,
  DisciplineFilePackPayload,
  DisciplineFilesTask,
} from './interfaces'

import { DisciplineFilePackOwner } from './enums'
import { formatTaskDate } from './tutor-tasks/tutor-tasks'

const UNKNOWN_CATEGORY = 'Unknown category'

/** HOMEWORK and OTHER exist in both lists with different labels: the pack's owner picks the list. */
export const getPackCategories = (owner: DisciplineFilePackOwner, lists: ListFile | null): Record<string, string> =>
  (owner === DisciplineFilePackOwner.Discipline ? lists?.category_customer : lists?.category) ?? {}

export const getPackCategoryLabel = (owner: DisciplineFilePackOwner, category: string, lists: ListFile | null): string =>
  getPackCategories(owner, lists)[category] ?? UNKNOWN_CATEGORY

export const getPackFilesText = (count: number): string | null =>
  count > 0 ? `${count} file(-s) sent` : null

export const getTaskOptionText = (task: DisciplineFilesTask): string =>
  `Task ${task.type} (${formatTaskDate(task.due_date)})`

export const buildPackForm = (pack: DisciplineFilePackDetails): Required<DisciplineFilePackPayload> => ({
  category: pack.category,
  comment: pack.comment,
  tutor_id: pack.tutor_id,
  task_id: pack.task?.id ?? null,
})

export const isPackFormChanged = (pack: DisciplineFilePackDetails, form: Required<DisciplineFilePackPayload>): boolean => {
  const initial = buildPackForm(pack)
  return (Object.keys(initial) as (keyof DisciplineFilePackPayload)[]).some(key => initial[key] !== form[key])
}
